/**
 * Node identity for a system in the layout graph.
 *
 * Edges reference systems by this string, so every producer of a `SystemGroup`
 * must compose it the same way — a mismatch silently drops the edge.
 */
export function composeSystemId(domain: string | undefined, key: string): string {
  return domain ? `${domain}-${key}` : key;
}

/** Splits a catalog entity name back into the parts that recompose it. */
export function splitSystemName(
  entityName: string,
  domain: string | undefined,
): { domain: string; key: string } {
  if (domain && entityName.startsWith(`${domain}-`)) {
    return { domain, key: entityName.slice(domain.length + 1) };
  }
  return { domain: '', key: entityName };
}
